import React from 'react';
import { downloadPersonalDataProtectionDocumentAction } from '../../../../../../services/request';
import { WorkStandardsGeneric } from './generics/WorkStandardsGeneric';

export const PersonalDataProtectionDocuments = () => (
  <WorkStandardsGeneric
    downloadDocumentAction={downloadPersonalDataProtectionDocumentAction}
    serializerFieldName="personal_data_protection_documents"
    title="Dokumentacja dotycząca ochrony danych osobowych"
    showChecked={false} />
);
